import { useBack } from "../http";
import {
	EpiActionHistoryDTO, EpiCorrectiveActionDTO, EpiCorrectiveActionUpdateDTO, EpiResponsibleDTO
} from "../types/EpiCorrectiveActionDTO";

export class EpiCorrectiveActionService {
	constructor() {}
	axiosInstance = useBack();

	async list(companyId: number) {
		try {
			const response = await this.axiosInstance
				.get<EpiCorrectiveActionDTO[]>(`/epi-inspections/actions/company/${companyId}`);
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter as não conformidades`, error);
			return undefined;
		}
	}

	async listResponsibles(companyId: number) {
		try {
			const response = await this.axiosInstance
				.get<EpiResponsibleDTO[]>(
					`/epi-inspections/actions/company/${companyId}/responsibles`);
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter os responsáveis disponíveis`, error);
			return undefined;
		}
	}

	async history(actionId: number) {
		try {
			const response = await this.axiosInstance
				.get<EpiActionHistoryDTO[]>(`/epi-inspections/actions/${actionId}/history`);
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter o histórico da ação`, error);
			return undefined;
		}
	}

	async update(actionId: number, body: EpiCorrectiveActionUpdateDTO) {
		const response = await this.axiosInstance
			.put<EpiCorrectiveActionDTO>(`/epi-inspections/actions/${actionId}`, body);
		return { ...response };
	}
}
